
 var route = {
    path : '/register/campus',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            cb(null, require('../pc/CampusRegister.jsx').default)
        }, 'CampusRegister')
    }
}


export default route;


// WEBPACK FOOTER //
// ./src/routes/campus-register.js